import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/shared/services/angular-service/common.services';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { CompanyService } from 'src/app/shared/services/node-api/company.service';

@Component({
  selector: 'app-company-list-component',
  templateUrl: './company-list-component.component.html',
  styleUrls: ['./company-list-component.component.scss'],
})
export class CompanyListComponentComponent implements OnInit {
  @Input() page: any;
  cols: any[];
  companyList: any = [];
  toRecords: any = 0;
  rowsPerPageOptions = ['24', '48', '72', '96'];
  paginationRequest = {
    field: 'total_valuation',
    order: -1,
    rows: 18,
    page: 0,
    filter: {},
    totalRecords: 0,
  };

  public selectedFilters: any;
  public selectSortFilters: any = {
    selectedOption: "Relevance"
  };
  public selectedSearch: string = '';
  public isSearching = true;
  deviceType;
  isFilterVisible = true;

  constructor(
    private companyService: CompanyService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private localStorage: LocalStorageService
  ) {
    this.deviceType = localStorage.getItem('deviceType');
    if (this.deviceType === 'mobile') {
      this.isFilterVisible = false;
    }
  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params: any) => {
      if (this.selectedSearch != params.params.s) {
        this.companyList = [];
        this.selectedSearch = params.params.s;
        this.modifyFilet();
        // this.modifyFilter();
      }
      console.log();
    });
  }

  getCompanies() {
    this.isSearching = true;
    let query = {
      field: this.paginationRequest.field,
      order: this.paginationRequest.order,
      rows: this.paginationRequest.rows,
      page: this.paginationRequest.page,
      filter: this.paginationRequest.filter,
      textSearch: this.selectedSearch,
    };
    this.companyService
      .getCompanies(query)
      .then((data) => {
        this.companyList = [...this.companyList, ...data['data']];
        this.paginationRequest.totalRecords = data['totalRecords']
          ? data['totalRecords']
          : 0;
        let toRecords =
          this.paginationRequest.rows * (this.paginationRequest.page + 1);
        this.toRecords =
          this.paginationRequest.totalRecords < toRecords
            ? this.paginationRequest.totalRecords
            : toRecords;
        this.isSearching = false;
      })
      .catch((err: any) => {
        // console.log(err)
        this.isSearching = false;
      });
  }

  isSorting = true;
  onSort(event: any) {
    this.isSorting = true;
  }

  customSort(event: any) {
    if (this.isSorting) {
      this.paginationRequest.field =
        this.cols[this.cols.findIndex((x) => x.header == event.field)].field;
      this.paginationRequest.order = event.order;
      this.getCompanies();
    }
  }

  //pagination
  paginate(event: any) {
    if (this.paginationRequest.page !== event.page) {
      this.paginationRequest.page = event.page;
      // this.router.navigate(["dashboard/company/list"], { queryParams: { page: this.paginationRequest.page } });
    }
    // this.paginationRequest.page = event.page;
    this.paginationRequest.rows = parseInt(event.rows);
    this.getCompanies();
  }

  //filter
  onFilter(event) {
    if (this.filter) {
      this.paginationRequest.filter = event.filters;
      this.paginationRequest.page = 0;
      this.getCompanies();
    }
  }

  filter = false;
  onClickFilter() {
    this.filter = true;
  }

  public noMore = false;
  onScroll(event) {
    // console.log('event', event);
    let page = this.paginationRequest.page + 1;
    if (page * 2400 < event.currentScrollPosition) {
      this.paginationRequest.page = page;
      if (
        this.paginationRequest.page >=
        this.paginationRequest.totalRecords / this.paginationRequest.rows
      ) {
        this.noMore = true;
      } else {
        this.getCompanies();
      }
    }
  }

  selectSortFilter(selectSortFilters) {
    this.selectSortFilters = selectSortFilters;
    this.modifyFilet();
    // this.modifyFilter();
  }

  selectedFilter(selectedFilters) {
    this.selectedFilters = selectedFilters;
    this.modifyFilet();
  }

  // modifyFilter() {
  //   if (
  //     (this.selectedSearch !== undefined &&
  //       this.selectedSearch !== null &&
  //       this.selectedSearch !== '') ||
  //     (this.selectSortFilters !== undefined &&
  //       this.selectSortFilters?.name !== undefined &&
  //       this.selectSortFilters.name !== null) ||
  //     (this.selectSortFilters !== undefined &&
  //       this.selectSortFilters?.lastest_revenue !== undefined &&
  //       this.selectSortFilters.lastest_revenue !== null) ||
  //     (this.selectSortFilters !== undefined &&
  //       this.selectSortFilters?.total_valuation !== undefined &&
  //       this.selectSortFilters.total_valuation !== null)
  //   ) {
  //     this.paginationRequest.page = 0;
  //     this.companyList = [];
  //     this.filter = true;

  //     this.paginationRequest.order = this.selectSortFilters.name
  //       ? this.selectSortFilters.name
  //       : this.selectSortFilters.lastest_revenue
  //         ? this.selectSortFilters.lastest_revenue
  //         : this.selectSortFilters.total_valuation;

  //     this.paginationRequest.field = this.selectSortFilters?.name
  //       ? 'name'
  //       : this.selectSortFilters?.lastest_revenue
  //         ? 'lastest_revenue'
  //         : 'total_valuation';
  //   } else {
  //     this.paginationRequest.page = 0;
  //     this.companyList = [];
  //     this.filter = false;
  //     this.paginationRequest.filter = {};
  //     this.paginationRequest.order = -1;
  //     this.paginationRequest.field = this.selectSortFilters?.name
  //       ? 'name'
  //       : this.selectSortFilters?.lastest_revenue
  //         ? 'lastest_revenue'
  //         : 'total_valuation';
  //   }
  //   this.getCompanies();
  // }

  modifyFilet() {
    // console.log(this.selectedSearch);
    // console.log(this.selectedFilters);

    if (
      (this.selectedSearch !== undefined &&
        this.selectedSearch !== null &&
        this.selectedSearch !== '') ||
      (this.selectSortFilters !== undefined &&
        this.selectSortFilters?.name !== undefined &&
        this.selectSortFilters.name !== null) ||
      (this.selectSortFilters !== undefined &&
        this.selectSortFilters?.lastest_revenue !== undefined &&
        this.selectSortFilters.lastest_revenue !== null) ||
      (this.selectSortFilters !== undefined &&
        this.selectSortFilters?.total_valuation !== undefined &&
        this.selectSortFilters.total_valuation !== null)
    ) {
      this.paginationRequest.page = 0;
      this.companyList = [];
      this.filter = true;

      this.paginationRequest.order = this.selectSortFilters.name
        ? this.selectSortFilters.name
        : this.selectSortFilters.lastest_revenue
          ? this.selectSortFilters.lastest_revenue
          : this.selectSortFilters.total_valuation;

      this.paginationRequest.field = this.selectSortFilters?.name
        ? 'name'
        : this.selectSortFilters?.lastest_revenue
          ? 'lastest_revenue'
          : 'total_valuation';
    } else {
      this.paginationRequest.page = 0;
      this.companyList = [];
      this.filter = false;
      this.paginationRequest.filter = {};
      this.paginationRequest.order = -1;
      this.paginationRequest.field = this.selectSortFilters?.name
        ? 'name'
        : this.selectSortFilters?.lastest_revenue
          ? 'lastest_revenue'
          : 'total_valuation';
    }

    if (
      (this.selectedSearch !== undefined &&
        this.selectedSearch !== null &&
        this.selectedSearch !== '') ||
      (this.selectedFilters !== undefined &&
        this.selectedFilters?.type_of !== undefined &&
        this.selectedFilters.type_of !== null &&
        this.selectedFilters.type_of.length > 0) ||
      (this.selectedFilters?.industry !== undefined &&
        this.selectedFilters.industry !== null &&
        this.selectedFilters.industry.length > 0) ||
      (this.selectedFilters?.headquaters_location !== undefined &&
        this.selectedFilters.headquaters_location !== null &&
        this.selectedFilters.headquaters_location.length > 0) ||
      (this.selectedFilters?.total_valuation !== undefined &&
        this.selectedFilters.total_valuation !== null &&
        this.selectedFilters.total_valuation.length > 0) ||
      (this.selectedFilters?.lastest_revenue !== undefined &&
        this.selectedFilters.lastest_revenue !== null &&
        this.selectedFilters.lastest_revenue.length > 0) ||
      (this.selectedFilters?.lastest_profit_n_loss !== undefined &&
        this.selectedFilters.lastest_profit_n_loss !== null &&
        this.selectedFilters.lastest_profit_n_loss.length > 0) ||
      (this.selectedFilters?.status !== undefined &&
        this.selectedFilters.status !== null &&
        this.selectedFilters.status.length > 0)
    ) {
      this.paginationRequest.page = 0;
      this.companyList = [];
      this.filter = true;
      this.paginationRequest.filter = {};
      if (this.selectedFilters) {
        Object.keys(this.selectedFilters).forEach((key: any) => {
          if (
            this.selectedFilters[key] &&
            this.selectedFilters[key].length > 0
          ) {
            this.paginationRequest.filter[key] = [];
            if (key == 'industry') {
              this.selectedFilters[key].forEach((value) => {
                this.paginationRequest.filter[key].push({
                  value: value,
                  matchMode: 'in',
                  operator: 'or',
                });
              });
            } else if (key == 'lastest_revenue' || key == 'total_valuation' || key == 'lastest_profit_n_loss') {
              if (this.selectedFilters[key] && this.selectedFilters[key].length === 2) {
                // Ensure there are exactly 2 values (for the range)
                this.paginationRequest.filter[key].push({
                  value: [this.selectedFilters[key][0], this.selectedFilters[key][1]], // Store the values as an array
                  matchMode: 'range',
                  operator: 'or',
                });
              }
            } else {
              this.selectedFilters[key].forEach((value) => {
                this.paginationRequest.filter[key].push({
                  value: value,
                  matchMode: 'equals',
                  operator: 'or',
                });
              });
            }
          }
        });
      }
    } else {
      // if (this.filter) {
      this.paginationRequest.page = 0;
      this.companyList = [];
      this.filter = false;
      this.paginationRequest.filter = {};
      // }
    }
    // console.log('Filters', JSON.stringify(this.paginationRequest.filter));
    this.getCompanies();
  }

  toggleFilterView() {
    this.isFilterVisible = !this.isFilterVisible;
  }
}
